module.exports = __webpack_public_path__ + "img/ic-neige.a650e6fc.svg";